import React, { useCallback } from 'react';
import { Button, Modal } from 'gatorcomponents';
import * as Styles from './TitanWithoutDomainModal.styles';
import useLocale from '@/hooks/useLocale';
import { useHistory } from 'react-router';
import { useResize } from '@/hooks/useResize';

const TitanWithoutDomainModal = ({
  onClose,
  hostingId,
}) => {
  const { titanWithoutDomain: titanWithoutDomainLocale, routes: routesLocale } = useLocale();
  const history = useHistory();
  const windowRect = useResize();
  const { width } = windowRect;

  const mobile = width < 600;

  const handleClose = useCallback(() => {
    onClose && onClose();
  }, [onClose]);

  const handleRedirectToTitanWithoutDomain = useCallback(() => {
    history.push(`${routesLocale.emailsList + routesLocale.changeDomain}/${hostingId}`);
  }, [history, routesLocale, hostingId]);

  return (
    <Modal
      maxWidth={500}
      open
      onClose={handleClose}
      title={titanWithoutDomainLocale.startModal.title}
      testId="modal-titan-without-domain"
      mobileMaxHeight="fit-content"
      alignModal={mobile ? 'end' : 'center'}
    >
      <Styles.Content>{titanWithoutDomainLocale.startModal.description}</Styles.Content>
      <Styles.ButtonWrapper>
        <Button onClick={handleRedirectToTitanWithoutDomain} size="large" label={titanWithoutDomainLocale.startModal.buttonLabel} width={mobile ? 'full' : 'fit'} />
      </Styles.ButtonWrapper>
    </Modal>
  );
};

export default TitanWithoutDomainModal;
